import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PLAYER_CYWTIWB, PLAYER_LIVE } from '../constants';
import Player from './Player';

class PromotionalCyw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerState: 'inactive',
    };
    this.handlePlayerStateChange = this.handlePlayerStateChange.bind(this);
  }

  handlePlayerStateChange = (newState) => {
    this.setState({ playerState: newState });
  };

  render() {
    const { curLang, auth } = this.props;
    const disablePlayBack = !auth ? true : false;

    return (
      <div className={`cyw-tiwb-banner cyw-player--${this.state.playerState}`}>
        {!disablePlayBack && (
          <Player
            curLang={curLang}
            isTriggerAutoPlay={false}
            type={PLAYER_CYWTIWB}
            wowzApplication={PLAYER_LIVE}
            onChange={this.handlePlayerStateChange}
            streamImg="cyw.jpg"
            prog={{
              series_title: 'CywTiwb',
              programme_title: ' ',
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
    auth: state.auth.authenticated,
  };
};

export default connect(mapStateToProps)(PromotionalCyw);
